module.exports = __webpack_public_path__ + "static/media/register.d95b6053.jpg";